import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import type { Murmur } from '../../types';

const GrowDashboard: React.FC = () => {
    // const [stocks, setStocks] = useState<UnlistedStock[]>([]);
    // const [loading, setLoading] = useState(true);
    const [murmurs, setMurmurs] = useState<Murmur[]>([]);
    const [murmursLoading, setMurmursLoading] = useState(true);

    useEffect(() => {
        // const fetchStocks = async () => {
        //     try {
        //         // Fetch featured stocks
        //         const response = await api.get('/unlisted-stocks?featured=true');
        //         if (response.data.success) {
        //             setStocks(response.data.data);
        //         }
        //     } catch (err) {
        //         console.error('Failed to fetch dashboard stocks:', err);
        //     } finally {
        //         setLoading(false);
        //     }
        // };

        const fetchMurmurs = async () => {
            try {
                const response = await api.get('/murmurs?limit=3');
                if (response.data.success) {
                    setMurmurs(response.data.data);
                }
            } catch (err) {
                console.error('Failed to fetch dashboard murmurs:', err);
            } finally {
                setMurmursLoading(false);
            }
        };

        // fetchStocks();
        fetchMurmurs();
    }, []);

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 animate-fade-in">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-slate-900 tracking-tight">Grow Your Wealth</h1>
                <p className="text-slate-600 mt-2 text-lg">
                    Discover new investment opportunities and market insights.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {/* Unlisted Shares Widget (Disabled)
                <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-6">
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h2 className="text-xl font-bold text-slate-900">Unlisted Stocks</h2>
                            <p className="text-slate-500 text-sm">Pre-IPO opportunities available now</p>
                        </div>
                        <Link to="/grow/unlisted" className="text-trade-primary hover:text-blue-700 font-medium text-sm">
                            View All
                        </Link>
                    </div>

                    {loading ? (
                        <div className="flex justify-center p-4">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-trade-primary"></div>
                        </div>
                    ) : stocks.length === 0 ? (
                        <div className="text-center py-8 bg-slate-50 rounded-lg">
                            <p className="text-slate-500 text-sm">New opportunities coming soon</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 gap-4">
                            {stocks.slice(0, 3).map((stock) => (
                                <div key={stock.id} className="min-w-[280px] bg-slate-50 rounded-xl p-4 border border-slate-100">
                                    <div className="flex items-center space-x-3 mb-3">
                                        {stock.image_url ? (
                                            <img
                                                src={stock.image_url.startsWith('http') ? stock.image_url : `/api${stock.image_url}`}
                                                alt={stock.name}
                                                className="w-10 h-10 rounded-lg object-cover bg-white shadow-sm"
                                                onError={(e) => {
                                                    (e.target as HTMLImageElement).src = `https://ui-avatars.com/api/?name=${encodeURIComponent(stock.name)}&background=random`;
                                                }}
                                            />
                                        ) : (
                                            <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 font-bold">
                                                {stock.name.substring(0, 2).toUpperCase()}
                                            </div>
                                        )}
                                        <div>
                                            <h4 className="font-bold text-slate-900">{stock.name}</h4>
                                            <p className="text-xs text-slate-500">{stock.sector}</p>
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-end">
                                        <div>
                                            <p className="text-xs text-slate-500 mb-1">Price</p>
                                            <p className="font-bold text-slate-900">₹{stock.price.toLocaleString()}</p>
                                        </div>
                                        <Link to={`/grow/unlisted-stocks/${stock.id}`} className="text-sm font-medium text-trade-primary hover:text-blue-700">
                                            View Details →
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                */}

                {/* Murmurs Widget */}
                <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-6">
                    <div className="flex items-center justify-between mb-6">
                        <div>
                            <h2 className="text-xl font-bold text-slate-900">Murmurs</h2>
                            <p className="text-slate-500 text-sm">Recent institutional buying</p>
                        </div>
                        <Link to="/grow/murmurs" className="text-trade-primary hover:text-blue-700 font-medium text-sm">
                            View All
                        </Link>
                    </div>

                    {murmursLoading ? (
                        <div className="flex justify-center p-4">
                            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-trade-primary"></div>
                        </div>
                    ) : murmurs.length === 0 ? (
                        <div className="text-center py-8 bg-slate-50 rounded-lg">
                            <p className="text-slate-500 text-sm">No recent activity detected</p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 gap-4">
                            {murmurs.map((m) => (
                                <div key={m.id} className="bg-slate-50 rounded-xl p-4 border border-slate-100 hover:border-slate-200 transition-all">
                                    <div className="flex justify-between items-start mb-2">
                                        <span className="font-bold text-slate-900 bg-white px-2 py-0.5 rounded border border-slate-200 text-xs tracking-wider">
                                            {m.symbol}
                                        </span>
                                        <span className="text-xs text-slate-500 font-medium">
                                            {new Date(m.timestamp).toLocaleTimeString('en-IN', {
                                                timeZone: 'Asia/Kolkata',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit'
                                            })}
                                        </span>
                                    </div>
                                    <div className="flex justify-between items-end">
                                        <div>
                                            <p className="text-xs text-slate-500 mb-0.5">Value</p>
                                            <p className="font-bold text-emerald-600">₹{parseFloat(m.value_crores.toString()).toFixed(2)} Cr</p>
                                        </div>
                                        <div className="text-right">
                                            <p className="text-xs text-slate-500 mb-0.5">Price</p>
                                            <p className="font-semibold text-slate-900">₹{parseFloat(m.price.toString()).toFixed(2)}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GrowDashboard;
